import React from "react";

const DisclaimerPage = () => {
  return (
    <>
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn conduct-header"
        data-wow-delay="0.1s"
      >
        <div className="container text-center py-5">
          <h4 className="display-5 text-white mb-4 animated slideInDown">
            Miễn trừ trách nhiệm
          </h4>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <a href="/">Trang chủ</a>
              </li>
              <li className="breadcrumb-item text-primary" aria-current="page">
                Miễn trừ trách nhiệm
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="styles_freeText__qCYU0 make-up-content">
              <p>
                <strong>Chính sách Miễn trừ Trách nhiệm</strong>
                <br />
                Trang web này được xây dựng và quản lý bởi [Bùi Thị Mỹ Quyên].
                Mục đích của trang web là cung cấp thông tin về các sản phẩm và
                dịch vụ của Shinhan và các chủ đề liên quan. Tuy nhiên, tôi xin
                lưu ý rằng:
                <br />
                <br />
                <strong>Không bảo đảm tính chính xác của thông tin</strong>
                <br />
                Mặc dù tôi nỗ lực cung cấp thông tin chính xác và cập nhật, tôi
                không đảm bảo tính đầy đủ, chính xác hoặc không có sai sót của
                bất kỳ thông tin nào trên trang web này. Tất cả thông tin trên
                trang web chỉ mang tính chất tham khảo và tôi không chịu trách
                nhiệm về bất kỳ tổn thất nào phát sinh từ việc sử dụng thông tin
                này.
                <br />
                <br />
                <strong>
                  Miễn trừ trách nhiệm về quyết định của người sử dụng
                </strong>
                <br />
                Việc sử dụng thông tin từ trang web này và các quyết định dựa
                trên thông tin đó hoàn toàn do người dùng tự chịu trách nhiệm.
                Tôi không chịu trách nhiệm về bất kỳ hậu quả nào liên quan đến
                việc áp dụng thông tin từ trang web này vào các quyết định tài
                chính, đầu tư, hoặc bất kỳ quyết định nào khác.
                <br />
                <br />
                <strong>Không chịu trách nhiệm về liên kết bên ngoài</strong>
                <br />
                Trang web có thể chứa các liên kết đến các trang web bên ngoài.
                Tuy nhiên, tôi không kiểm soát và không chịu trách nhiệm về nội
                dung hoặc các hoạt động của các trang web bên ngoài này. Việc
                truy cập các liên kết này hoàn toàn là lựa chọn của người dùng
                và tôi không chịu trách nhiệm về bất kỳ thiệt hại nào phát sinh
                từ việc truy cập các trang web này.
                <br />
                <br />
                <strong>Miễn trừ trách nhiệm về gián đoạn dịch vụ</strong>
                <br />
                Tôi không đảm bảo rằng trang web sẽ hoạt động liên tục hoặc
                không gặp sự cố kỹ thuật. Trong trường hợp có sự cố kỹ thuật
                hoặc gián đoạn dịch vụ, tôi không chịu trách nhiệm về bất kỳ
                thiệt hại nào xảy ra trong quá trình sử dụng trang web.
                <br />
                <br />
                <strong>Quyền sở hữu trí tuệ</strong>
                <br />
                Mọi nội dung trên trang web, bao gồm văn bản, hình ảnh, đồ họa,
                video, và các tài liệu khác, thuộc quyền sở hữu của tôi hoặc các
                bên liên quan. Các nội dung này được bảo vệ bởi các quyền sở hữu
                trí tuệ và không được phép sao chép, phân phối hoặc sử dụng mà
                không có sự đồng ý của tôi.
                <br />
                <br />
                <strong>Điều khoản sử dụng</strong>
                <br />
                Bằng việc sử dụng trang web này, bạn đồng ý tuân thủ các điều
                khoản và điều kiện mà tôi đã đề ra. Nếu bạn không đồng ý với các
                điều khoản này, vui lòng ngừng sử dụng trang web.
                <br />
                <br />
                <strong>Thay đổi Chính sách</strong>
                <br />
                Tôi có quyền thay đổi hoặc cập nhật chính sách miễn trừ trách
                nhiệm này bất kỳ lúc nào mà không cần thông báo trước. Mọi thay
                đổi sẽ có hiệu lực ngay khi được đăng tải trên trang web. Người
                dùng có trách nhiệm kiểm tra định kỳ các điều khoản này để cập
                nhật những thay đổi.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisclaimerPage;
